// extracted by mini-css-extract-plugin
export var checkbox = "checkbox-module--checkbox--17cbc";
export var checkmark = "checkbox-module--checkmark--62a4a";
export var disabled = "checkbox-module--disabled--17816";
export var icon = "checkbox-module--icon--1a94b";
export var inline = "checkbox-module--inline--84149";
export var input = "checkbox-module--input--75c17";
export var leftMargin = "checkbox-module--leftMargin--4a0b1";
export var link = "checkbox-module--link--e93b5";
export var linkDisabled = "checkbox-module--link--disabled--46b34";